import { ReactNode, useMemo } from 'react';

import { DriverOptionsContext, driverOptionsContext } from './driverOptionsContext';
import { useFetchDriverOptions } from '../../hooks/useFetchDriverOptions';
import { useFetchUser } from '../../hooks/useFetchUser';

type Props = {
  children: ReactNode;
};

export const DriverOptionsProvider = ({ children }: Props) => {
  const { data: user } = useFetchUser();
  const { data: driverOptions, isFetched } = useFetchDriverOptions();

  const contextValue = useMemo<DriverOptionsContext>(
    () => ({
      isReady: isFetched,
      driverOptions: {
        seePriceWithCommission: driverOptions?.seePriceWithCommission ?? false,
        isSubjectToVAT: user?.tva ?? true,
      },
    }),
    [driverOptions?.seePriceWithCommission, isFetched, user?.tva],
  );

  return <driverOptionsContext.Provider value={contextValue}>{children}</driverOptionsContext.Provider>;
};
